import RegularUtil from '../../utils/RegularUtil';
export default class FormItemLongDisplay
{
	
	static THOUSANDSEPERATORCHAR = ",";
	
	static getDisplayText(value,showZero,thousandSeperator)
	{
		value = value+"";
		if(value==null || value == "")
		{
			return "";
		}
		else
		{
			return FormItemLongDisplay.formatLabel(value,showZero,thousandSeperator);
		}
		
	}
	
	//数字前面的零在getResult中已经被过滤掉
	static filtZero(input)
	{
		var i = 0;
		var result;
		var flag = Number(input) < 0 ? true:false;
		if(flag)
		{
			while(input.charAt(i) == "-" || input.charAt(i) == "0")
			{
				i++;
			}
		}
		else
		{
			while(input.charAt(i) == "0")
			{
				i++;
			}
		}
		
		result = input.substr(i);
		
		if(flag)
			result = "-" + result;
		
		return result.split("");
	}
	
	static formatLabel(value,showZero,thousandSeperator)
	{
		
		if(value == null)
			return "";
		var chars;
		if(value == "0")
		{
			if(showZero)
			{
				return value;
			}
			else
			{
				return "";
			}
		}
		
		
		if(!thousandSeperator)
			return value;
			
		if(Number(value)<0)
		{
			if(value.length < 5)
			{
				return value;
			}
			else
			{
				chars = FormItemLongDisplay.filtZero(value);
			}
		}
		else
		{	
			if(value.length < 4 )
			{
				return value;
			}
			else
			{
				chars = FormItemLongDisplay.filtZero(value);
			}
		}
		
		if(chars == null)
		{
			chars = value.split("");
		}
		
		
		return RegularUtil.setThounsandSeperator(chars,FormItemLongDisplay.THOUSANDSEPERATORCHAR);
		
	}
}



// WEBPACK FOOTER //
// ./src/formItem/display/FormItemLongDisplay.js